<template>
  <div id="div-with-loading" class="w-full vs-con-loading__container" style="height: 300px">
    <div class="w-full">
      <div class="flex justify-end items-end">
        <div class="w-full relative">
          <vs-input
            class="w-full mt-0 address_map"
            placeholder="Ejem: calle 84 # 24 - 78, Bogotá"
            :label="$t(`PROFILEVIEW.address`)"
            v-model="user.address"
            type="text"
            v-validate="'required'"
            name="address"
          />
          <div v-if="assisted" class="list-cities rounded rounded-t-none overflow-auto">
            <ul>
              <li
                @click="geocoder(address)"
                class="
                  item-city
                  px-3
                  py-3
                  border-b border-t-0 border-r-0 border-l-0 border-solid border-gray-100
                  cursor-pointer
                "
                v-for="(address, index) in arrayAddress"
                :key="index"
              >
                {{ address }}
              </li>
            </ul>
          </div>
        </div>

        <button class="btn_map" @click="_assisted(user.address)">
          <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
        </button>
      </div>
    </div>
    <div id="_map" class="_map"></div>
    <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first("address") }}</span>
  </div>
</template>

<script>
import Api from "@/helpers/api";
import { loading, closeLoding, notify } from "@/helpers/$vs.js";
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    arrayAddress: [],
    assisted: false
  }),
  methods: {
    async geocoder(address) {
      loading("default", "#div-with-loading");
      const split_address = address.split(":");
      if (split_address[1] === undefined) split_address[1] = address;
      try {
        const data = {
          address: split_address[1],
          city: this.city_assisted
        };
        const result = await Api.post("/geocoder", data);
        const address = `${result.data.address} ${this.city_assisted}, ${result.data.department}`;
        this.user = {
          ...this.user,
          address,
          latitude: parseFloat(result.data.latitude),
          longitude: parseFloat(result.data.longitude)
        };
        this.moveMarker(result.data.latitude, result.data.longitude);
        this.assisted = false;
      } catch (error) {
        console.log("Error: geocoder", error);
      } finally {
        closeLoding("div-with-loading");
      }
    },
    async _assisted(_address) {
      loading("default", "#div-with-loading");
      const split_address = _address.split(",");
      const address = split_address[0];
      const city = (this.city_assisted = split_address[1]);

      try {
        const data = { address, city };
        const result = await Api.post("/assisted", data);
        this.assisted = true;
        result.data.pop();
        this.arrayAddress = result.data;
      } catch (error) {
        console.log("Error: reversed", error);
        notify(
          this.$t(`PROFILEVIEW.address`),
          this.$t(`PROFILEVIEW.textValidationAddress`),
          "danger"
        );
      } finally {
        closeLoding("div-with-loading");
      }
    },
    moveMarker(lat, lng) {
      Anuket.removeMarkers();
      Anuket.addMarker({ lat, lng }, this.options);
      Anuket.centerMap(lat, lng);
    }
  },
  computed: {
    user: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style >
._map {
  height: 225px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.btn_map {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-left: none;
  background: white;
  width: 60px;
  height: 37.3px;
  border-top-right-radius: 5px;
  cursor: pointer;
}

.btn_map:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.address_map .vs-input--input {
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
</style>

<style lang="scss" scoped>
.list-cities {
  position: absolute;
  height: auto;
  max-height: 150px;
  width: 100%;
  z-index: 1000000000;
  background: rgba($color: #ffffff, $alpha: 0.9);

  .item-city:hover {
    background: rgba($color: #e6e6e6, $alpha: 0.2);
  }
}
</style>
